<div class="table-scroll-container">
  <dsy-table zebraShadowRows [data]="data()" [conf]="config">
    <ng-container *ngFor="let col of columns">
      <p
        [attr.slot]="'header-' + col.key"
        [ngClass]="{ 'header--index': col.key === 'index', 'header--interval': col.key === 'timeInterval' }"
        class="header"
      >
        {{ col.header }}
      </p>
    </ng-container>

    <ng-container *ngFor="let offer of offers; let i = index">
      <div [attr.slot]="'cell-' + i + '-index'" class="cell cell--index">{{ i + 1 }}</div>

      <div [attr.slot]="'cell-' + i + '-timeInterval'" class="cell cell--timeInterval">
        {{ formatInterval(offer) }}
        <span class="cell--timeInterval-utc">{{ formattedTimeZone() }}</span>
      </div>

      <!-- Forecast (DEMAND_FORECAST) -->
      <div *ngIf="hasColumn('forecast')" [attr.slot]="'cell-' + i + '-forecast'" class="cell cell--forecast">
        <span class="cell--number">{{ offer.demand }}</span>
      </div>

      <!-- Baseline (BASELINE) -->
      <div *ngIf="hasColumn('baseline')" [attr.slot]="'cell-' + i + '-baseline'" class="cell cell--baseline">
        <span class="cell--number">{{ offer.baselines ?? '-' }}</span>
      </div>

      <!-- Capacity: split (↑/↓) when KW_TO_INCREASE/DECREASE present, else single (kW) -->
      <ng-container *ngIf="hasColumn('capacity')">
        <ng-container *ngIf="isCapacitySplit; else capacitySingle">
          <div [attr.slot]="'cell-' + i + '-capacity'" class="cell cell--capacity">
            <div *ngIf="hasCapacityIncrease" class="cell--arrow-container">
              <dsy-icon name="arrow_upward" library="material" size="1rem" color="#00A879"></dsy-icon>
              <span class="cell--number">{{ offer.capacity.max ?? '-' }}</span>
            </div>
            <div *ngIf="hasCapacityDecrease" class="cell--arrow-container">
              <dsy-icon name="arrow_downward" library="material" size="1rem" color="#E8384F"></dsy-icon>
              <span class="cell--number">{{ offer.capacity.min ?? '-' }}</span>
            </div>
          </div>
        </ng-container>
        <ng-template #capacitySingle>
          <div [attr.slot]="'cell-' + i + '-capacity'" class="cell cell--capacity">
            <span class="cell--number">{{ offer.capacity.value ?? '-' }}</span>
          </div>
        </ng-template>
      </ng-container>

      <!-- Price: split (↑/↓) when PRICE_TO_INCREASE/DECREASE present, else single (PRICE) -->
      <ng-container *ngIf="hasColumn('price')">
        <ng-container *ngIf="isPriceSplit; else priceSingle">
          <div [attr.slot]="'cell-' + i + '-price'" class="cell cell--price">
            <div *ngIf="hasPriceIncrease" class="cell--arrow-container">
              <dsy-icon name="arrow_upward" library="material" size="1rem" color="#131416"></dsy-icon>
              <span class="cell--number">{{ offer.price.max ?? '-' }}</span>
            </div>
            <div *ngIf="hasPriceDecrease" class="cell--arrow-container">
              <dsy-icon name="arrow_downward" library="material" size="1rem" color="#131416"></dsy-icon>
              <span class="cell--number">{{ offer.price.min ?? '-' }}</span>
            </div>
          </div>
        </ng-container>
        <ng-template #priceSingle>
          <div [attr.slot]="'cell-' + i + '-price'" class="cell cell--price">
            <span class="cell--number">{{ offer.price.value ?? '-' }}</span>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </dsy-table>
</div>
